'use strict';

export default class StudentsController {
	/*@ngInject*/
	constructor($http, EditStudentFactory, CreateStudentFactory){
		this.$http = $http;
		this.students = [];
		this.EditStudentFactory = EditStudentFactory;
		this.CreateStudentFactory = CreateStudentFactory;
	}

	$onInit(){
		this.loadStudents();
	}

	addStudent(){
		this.CreateStudentFactory().then(res => this.loadStudents());
	}

	loadStudents(){
		this.$http.get('/api/students').then(res => {
			this.students = res.data;
			this.students = this.students.map(student => {
				student.fullName = student.nameFirst + ' ' + student.nameLast;

				return student;
			})
		})
	}

	locationReturn(letter){
		if(letter === 'O'){
			return 'Online'
		}

		if(letter === 'H'){
			return 'Home'
		}

		if(letter === 'P'){
			return 'Paddington'
		}

		if(letter === 'C'){
			return 'Cannon Hill'
		}

		if(letter === 'M'){
			return 'Mt Gravatt'
		}

	}

	toggleActivate(student){

	  	student.isActive = !student.isActive;

	  	this.$http.put('/api/students/' + student._id, student).then(res => {
	  		console.log('student toggled');
	  	})
	}

	editStudent(studentID){
		//note that this accepts the ._id versio of ID, not tutorID
		this.EditStudentFactory(studentID).then(res => this.loadStudents());
	}
}


// WEBPACK FOOTER //
// ./client/app/students/students.controller.js